(function () {
    'use strict';

    var app = angular.module("app");

    app.value('session', {
        User: null
    })

    app.constant("constants", {
        projectType: { project: 1, ticket: 2, maintenance: 3 },
        pricingType: { timeAndMaterials: 0, quotedPrice: 1, flatRate: 2, unbillable: 3, perVisit: 4 },
        projectStatus: { unscheduled: 0, scheduled: 1, waitingOnParts: 2, completed: 3 },
        cannedResponseType: { consultation: 0, proposal: 1 },
        invoiceGrouping: { perWorkarea: 1, perVisit: 2, perItem: 3, perGroup: 4 },
        project: { detail_id: -1, job_costing_id: -2 },
        itemClasses: { labor: 0, equipment: 1, materials: 2, subcontracting: 3, other: 99, jobActivity: 4 },
        templateClassId: 98,
        fixedCosts: { labor: 29.49, equipment: 465 },
        colors: { labor: "#F0F000", equipment: "#FF5252", materials: "#42A5F5", subcontracting: "#FFA500", other: "#9932CC", jobActivity: "#00F5F5", overhead: "#008B8B", profit: "#00CC00" },
        pagination: { limit: 25 },
        timecardInternalNotesInputMode: { showButNotRequireInput: 1, showAndRequireInput: 2, showAndRequireOnlyWhenPricingOverridesHaveBeenMade: 3, hide: 4 },
        timecardClientNotesInputMode: { showAndNotificationOffByDefault: 1, showAndNotificationOnByDefault: 2, showAndRequiredNotificationOnByDefault: 3, hide: 4 },
        previousRouteAttachments: "",
        permissionKeys: { allowInvoicing: "allow_invoicing"}
    })

    app.constant("_", window._);

})();
